<!-- Mobile/tablet: horizontal tab bar -->
<nav class="flex flex-row bg-white border-b border-grey-200 lg:hidden">
  <button type="button" *ngFor="let item of navItems"
    class="px-4 py-2.5 text-sm whitespace-nowrap rounded-none border-b-2 uppercase tracking-wide" [ngClass]="activeSection === item.id
      ? 'font-semibold nav-item-active border-blue-600'
      : 'text-grey-500 border-transparent hover:bg-grey-100'" (click)="select(item.id)">
    {{ item.label }}
  </button>
</nav>

<!-- Desktop: vertical sidebar -->
<nav class="hidden lg:flex flex-col pt-3 bg-white h-full">
  <button type="button" *ngFor="let item of navItems"
    class="mx-2 mb-1 px-4 py-2.5 rounded cursor-pointer text-sm text-left flex items-center gap-2" [ngClass]="activeSection === item.id
      ? 'bg-blue-50 font-semibold nav-item-active'
      : 'text-grey-700 hover:bg-grey-100'" (click)="select(item.id)">
    <mat-icon *ngIf="item.icon" class="text-grey-400" style="font-size: 18px; height: 18px; width: 18px;">{{ item.icon }}</mat-icon>
    <span>{{ item.label }}</span>
  </button>
</nav>